import m from "./isSymbol.js";
var k = m;
function q(n, r) {
  if (n !== r) {
    var A = n !== void 0, _ = n === null, c = n === n, p = k(n), i = r !== void 0, j = r === null, d = r === r, g = k(r);
    if (!j && !g && !p && n > r || p && i && d && !j && !g || _ && i && d || !A && d || !c)
      return 1;
    if (!_ && !p && !g && n < r || g && A && c && !_ && !p || j && A && c || !i && c || !d)
      return -1;
  }
  return 0;
}
var z = q;
export {
  z as default
};
//# sourceMappingURL=_compareAscending.js.map
